import { Telemetry,ValidTelemetryEvent } from '~commonInfra/services/Telemetry';

enum EventType {
  AuthorConfiguredDCROn = 'monitoring_author_configuration_on',
  AuthorConfiguredDCROff = 'monitoring_author_configuration_off',
}

export enum DCRTelemetryEventSource {
  ViewActionMenu = 'view_action_menu',
}

interface CreateDataMonitoringEvent extends ValidTelemetryEvent {
  type: 'data_monitoring_events';
  event_type: EventType;
  view_luid: string;
  event_source: DCRTelemetryEventSource;
}

export function sendAuthorConfiguredDCRTelemetry(shouldMonitor: boolean, viewLuid: string, eventSource: DCRTelemetryEventSource) {
  Telemetry.sendEvent<CreateDataMonitoringEvent>({
    type: 'data_monitoring_events', // Sets this data up to go to the EVENT_DATA_MONITORING_EVENTS table in snowflake
    event_type: shouldMonitor ? EventType.AuthorConfiguredDCROn : EventType.AuthorConfiguredDCROff,
    view_luid: viewLuid,
    event_source: eventSource
  });
}
